export default __webpack_public_path__ + "static/media/mailico.c19a5d7c.svg";